<template>
    <div class="card card-custom gutter-b col-lg-13 col-xxl-12 mt-5 p-5">
        <div class="d-flex flex-row justify-content-between align-items-baseline">
            <div style="width: 15%">
                <router-link v-if="prevRoute" :to="prevRoute.fullPath" replace>
                    <span class="btn btn-outline-danger btn-md">
                        <span class="svg-icon svg-icon-md svg-icon-light-danger">
                            <inline-svg src="/media/svg/icons/Navigation/Arrow-left.svg"></inline-svg>
                        </span>
                        {{ $t('CONTROLLERS.BACK') }}
                    </span>
                </router-link>
            </div>
            <div class="d-flex flex-column justify-content-between align-items-center" style="max-width: 60%">
                <p class="mb-2 h3 text-center">Vos liens d'inscription de stagiaires pour la classe</p>
                <p class="mb-4 h3 text-center">
                    <a style="word-break: keep-all" class="text-primary">{{ classCustomer.classe.title }}</a>
                </p>
                <p class="h5 text-muted">Gestionnaire : {{ classCustomer.customer.name }}</p>
            </div>
            <span class="mr-1 p-right">
                <button
                    class="btn btn-outline-primary btn-md btn-md"
                    @click="$bvModal.show('class-customer-link-modal')"
                    v-if="$store.getters.currentUser.role === 'admin'"
                >
                    Nouveau lien d'inscription
                </button>
            </span>
        </div>
        <ClassesLinkManagerTable
            ref="table"
            @new-link="$bvModal.show('class-customer-link-modal')"
            :classCustomerId="parseInt(classCustomerId)"
            :classeId="parseInt(classCustomerId)"
            :customerId="parseInt(classCustomer.customer.id)"
        />
        <ClassesCustomersGenerateLink
            @finish-create="$refs.table.getLinks()"
            :customerId="parseInt(classCustomer.customer.id)"
            :classeId="parseInt(classCustomerId)"
            :classeTitle="classCustomer.classe.title"
            :classeCustomer="classCustomer"
        />
    </div>
</template>

<script>
import ClassesLinkManagerTable from '@/view/content/widgets/manager/ClassesLinkManagerTableWidget.vue';
import ClassesCustomersGenerateLink from '@/view/content/widgets/admin/modal/ClassesCustomersGenerateLink';
import ApiService from '@/core/services/api.service';

export default {
    //mixins: [validationMixin],
    components: {
        ClassesCustomersGenerateLink,
        ClassesLinkManagerTable
    },
    data() {
        return {
            classCustomer: {},
            classCustomerId: null,
            prevRoute: null
        };
    },
    mounted() {
        this.classCustomerId = this.$route.params.classesCustomersId;
        if (this.$route.params.classesCustomers) {
            this.classCustomer = {
                ...this.$route.params.classesCustomers,
                classe: { ...this.$route.params.classesCustomers.classe },
                customer: { ...this.$route.params.classesCustomers.customer }
            };
        } else {
            this.getClientsClasses();
        }
    },
    methods: {
        getClientsClasses() {
            ApiService.get('academy/clientclasses', this.classCustomerId).then((result) => {
                this.classCustomer = {
                    ...result.data.data[0],
                    classe: { ...result.data.data[0].classe },
                    customer: { ...result.data.data[0].customer }
                };
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prevRoute = from;
        });
    },
    computed: {}
};
</script>
